export default {
  templateDesign: null,
  templateData: null,
  formData: null,
  templates: [],
  campaigns: [],
  templateId: null,
  template: null,
  segments: [],
  segment: {},
  segmentSubscribers: [],
  segmentAddDialog: false,
  segmentUpdateDialog: false,
  segmentCloneDialog: false,
  segmentGroups: [],
  hasChanges: false,
  campaignSavedData: null,
  flows: [],
  flowId: null,
  flowSequence: null,
  campaignSelectedLocations: [],
  initialMenuItems: null,
  updateCampaign: false,
  updateOtherCampaign: false,
  campaignItem: null,
  otherCampaignItem: null,
  otherCampaignItems: null,
  segmentObj: {}
};
